module.exports = {
  title: "Ads analyzer",

  dialog: {
    loadView: {
      title: "Load query with filters"
    },
    saveView: {
      title: "Save query with filters"
    }
  },

  saveCSV: "CSV",
  saveTSV: "TSV",
  tips: "Semgregate AI Tips & Tricks",
  tipApplyFilter: "Apply Filter!",
  computing: {
    title: "Computing...",
    text: "Please wait."
  },
  filtering: {
    title: "Filtering...",
    text: "Please wait."
  },
  empty: "No results found",
  failed: "Processing failed",
  wrongType: {
    title: "Wrong report type",
    text: "Ads processor can process only ads reports. Please load another report or switch to another processor."
  },

  query: {
    title: "Query",
    filterResults: "Filter results",
    aggregateUrls: "Aggregate URLs"
  },

  filename: "file: ",

  endInfo: {
    'download': ({ allRows, visibleRows }) => `There is ${allRows - visibleRows} more ads. You can download full table.`,
    'premium': ({ allRows, visibleRows }) => `There is ${allRows - visibleRows} more ads. To see them all you need premium account.`
  }
}


// WEBPACK FOOTER //
// ../i18n/en/ads.js